<script setup>
import { Card, CardHeader, CardContent, CardFooter, CardTitle, CardDescription } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const props = defineProps({
    class: {
        type: String,
        required: false
    },
    headerClass: {
        type: String,
        required: false
    },
    contentClass: {
        type: String,
        required: false
    },
    footerClass: {
        type: String,
        required: false
    }
})
</script>

<template>
    <Card :class="cn('w-full shadow-none border border-primary-border', props.class)">
        <CardHeader v-if="$slots.header" :class="cn('', props.headerClass)">
            <slot name="header">
                <CardTitle>
                    <slot name="title" />
                </CardTitle>
                <CardDescription>
                    <slot name="description" />
                </CardDescription>
            </slot>
        </CardHeader>
        <CardContent v-if="$slots.content" :class="cn('', props.contentClass)">
            <slot name="content" />
        </CardContent>
        <CardFooter v-if="$slots.footer" :class="cn('', props.footerClass)">
            <slot name="footer" />
        </CardFooter>
    </Card>
</template> 